import React, { Fragment, useRef } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import clsx from "clsx";
import { Tooltip } from "../Tooltip";
import { Draggable } from "react-beautiful-dnd";
import { Box } from "@mui/system";
import { DragIndicator } from "@mui/icons-material";

const BodyRow = ({
  row,
  classes,
  getRowTooltipProps,
  getRowClass,
  rowSelectionDisabled,
  onRowClick,
  getRowProps,
  onTableCellClick,
  detailPanel,
  cellSize,
  index,
  visibleColumns,
  moveRow
}) => {
  const rowRef = useRef(null);
  const tableRowTooltipProps = getRowTooltipProps && getRowTooltipProps(row);

  const rowProps = isDragging => ({
    className: clsx(classes.rowClass, getRowClass && getRowClass(row), {
      [classes.rowExpanded]: row.isExpanded,
      [classes.disabled]: !!rowSelectionDisabled && rowSelectionDisabled(row),
      [classes.isDragging]: isDragging
    }),
    hover: (!!detailPanel && !row.isExpanded) || !!onRowClick,
    ...row.getRowProps(getRowProps(row))
  });

  const tableCells = row.cells.map(cell => {
    return (
      <TableCell
        onClick={() => onTableCellClick(row, cell)}
        {...cell.getCellProps()}
        style={cell.column.style}
        size={cellSize}
      >
        {cell.render("Cell")}
      </TableCell>
    );
  });

  let tableRow = null;

  if (moveRow) {
    tableRow = (
      <Draggable draggableId={`${row.id}`} index={index}>
        {(provided, snapshot) => (
          <>
            <TableRow
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...rowProps(snapshot.isDragging)}
              style={provided.draggableProps.style}
            >
              {tableCells}
              <TableCell key="key-drag-column">
                <Box {...provided.dragHandleProps} display="flex">
                  <DragIndicator color="action" />
                </Box>
              </TableCell>
            </TableRow>
          </>
        )}
      </Draggable>
    );
  } else {
    tableRow = (
      <TableRow ref={rowRef} {...rowProps()}>
        {tableCells}
      </TableRow>
    );
  }

  return (
    <Fragment key={row.id}>
      {!!tableRowTooltipProps ? (
        <Tooltip
          {...tableRowTooltipProps}
          areaRef={rowRef}
          TransitionProps={{
            exit: false
          }}
        >
          {tableRow}
        </Tooltip>
      ) : (
        tableRow
      )}
      {row.isExpanded && (
        <TableRow className={classes.expansionPanel}>
          <TableCell colSpan={visibleColumns.length}>
            {detailPanel({
              ...row.original,
              toggleRowSelected: row.toggleRowSelected
            })}
          </TableCell>
        </TableRow>
      )}
    </Fragment>
  );
};

export default BodyRow;

BodyRow.propTypes = {};
